<template>
  <div class="survey-all">
    <companyTitle></companyTitle>
    <b-pagination-nav
      :link-gen="linkGen"
      :number-of-pages="$store.getters.paginationInSurveyAll.last_page"
      @change="$store.dispatch('fetchSurveyAll', $event)"
      use-router
      class="mt-3"
    ></b-pagination-nav>
    <tableList
      :isSelectable="$store.getters.loggedInInfo.is_admin"
      :fields="fields"
      :items="$store.getters.surveyAllList"
      :sort-by.sync="sortBy"
      @click="openModal($event)"
      @toDetail="toDetail"
    >
    </tableList>
    <tableListNoData
      v-if="$store.getters.surveyAllList.length === 0"
    ></tableListNoData>

    <!-- modal -->
    <b-modal ref="double-check-delete-surveyAll">
      <p class="text-center">是否刪除？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >確定</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import tableList from "@/components/TableList.vue";
import tableListNoData from "@/components/TableListNoData.vue";
import companyTitle from "@/components/CompanyTitle.vue";
export default {
  components: {
    tableList,
    tableListNoData,
    companyTitle
  },
  computed: {
    sortBy() {
      return "";
    },
    fields() {
      return [
        { key: "released_at", label: "發布日期", sortable: true },
        { key: "title", label: "標題", sortable: true },
        { key: "user", label: "撰寫者", sortable: true }
      ];
    }
  },
  data() {
    return {
      deleteData: {
        research_ids: []
      }
    };
  },
  methods: {
    openModal(selectedList) {
      this.$refs["double-check-delete-surveyAll"].show();
      this.setDeleteData(selectedList);
    },
    setDeleteData(selectedList) {
      this.deleteData.research_ids = selectedList.map(item => item.id);
    },
    submit() {
      this.$store.dispatch("deleteOneSurvey", this.deleteData).then(() => {
        this.$refs["double-check-delete-surveyAll"].hide();
        const page = 1;
        this.$store.dispatch("fetchSurveyAll", page);
      });
    },
    toDetail(oneSurvey) {
      this.$router.push({
        name: "oneSurvey-read",
        params: { oneSurveyId: oneSurvey.id }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
